var render = function render(){var _vm=this,_c=_vm._self._c;return _c('navigation-menu-item',{attrs:{"target":"balance","title":"מצב העו״ש והאשראי","icon-name":"account_balance","disabled":!_vm.allowNavigationToBalancePage},on:{"navigate":function($event){return _vm.$emit('navigate')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }